import { useEffect, useState } from "react";

export const EDIT_FLOW_KEY = "assistantEditFlow";

export const setEditFlowFlag = () => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(EDIT_FLOW_KEY, "true");
};

export const clearEditFlowFlag = () => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(EDIT_FLOW_KEY);
};

export const getEditFlowFlag = () => {
  if (typeof window === "undefined") return false;
  return sessionStorage.getItem(EDIT_FLOW_KEY) === "true";
};

export default function useEditFlow(initialFlag = false) {
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (initialFlag) {
      setEditFlowFlag();
    }

    const flag = initialFlag || getEditFlowFlag();
    setIsEditing(flag);
  }, [initialFlag]);

  return isEditing;
}

